// Learner-runtime API helpers (Phase 18.2).
function backendBase() { return process.env.REACT_APP_BACKEND_URL || ''; }
function authHeader() {
  const t = localStorage.getItem('healthcues_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}
async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch (_) {}
  if (!res.ok) {
    const detail = body && body.detail;
    const err = new Error(typeof detail === 'string' ? detail : (detail?.message || `Request failed (${res.status})`));
    err.status = res.status;
    throw err;
  }
  return body;
}

export async function listMyCourses() {
  const r = await fetch(`${backendBase()}/api/learning/my-courses`, { headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function getMyCourse(id) {
  const r = await fetch(`${backendBase()}/api/learning/my-courses/${encodeURIComponent(id)}`, { headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function startCourse(id) {
  const r = await fetch(`${backendBase()}/api/learning/my-courses/${encodeURIComponent(id)}/start`, { method: 'POST', headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function completeLesson(courseId, lessonId) {
  const r = await fetch(`${backendBase()}/api/learning/my-courses/${encodeURIComponent(courseId)}/lesson-complete`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ lessonId }),
  });
  return jsonOrThrow(r);
}
export async function submitQuiz(courseId, answers) {
  const r = await fetch(`${backendBase()}/api/learning/my-courses/${encodeURIComponent(courseId)}/submit-quiz`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ answers }),
  });
  return jsonOrThrow(r);
}
export async function listMyCertificates() {
  const r = await fetch(`${backendBase()}/api/learning/my-certificates`, { headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function getMyCertificate(id) {
  const r = await fetch(`${backendBase()}/api/learning/certificates/${encodeURIComponent(id)}`, { headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function getGatingStatus() {
  const r = await fetch(`${backendBase()}/api/learning/gating-status`, { headers: { ...authHeader() } });
  return jsonOrThrow(r);
}
export async function verifyCertificatePublic(id) {
  // No auth required
  const r = await fetch(`${backendBase()}/api/public/verify-certificate/${encodeURIComponent(id)}`);
  return jsonOrThrow(r);
}

export function publicVerifyUrl(certId) {
  // The URL the QR code points to — opens the public verification page.
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}/verify-certificate/${encodeURIComponent(certId)}`;
}

export function qrImageUrl(certId, size = 180) {
  const url = publicVerifyUrl(certId);
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}`;
}
